import createReactAngularDirective from '../../lib/createReactAngularDirective';
import { ReturnMethodsPage } from '../../react-components/ReturnMethodsPage';
import s from '../../controllers/Step2Step3Ctrl/step2Step3Ctrl.module.css';

export default createReactAngularDirective({
  Component: ReturnMethodsPage,
  directiveName: 'returnMethodsPage',
  withProvider: true,
  replace: true,
  template: `<div class=${s.step_2_container}></div>`,
});
